import { Component, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { isEmpty } from './../../core/util';
import { PiecePostale } from '../../../entities/piece-jointe';

@Component({
    selector: 'jhi-piece-postales',
    templateUrl: './piece-postales.component.html',
    styleUrls: ['./piece-postales.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class PiecePostalesComponent {

    @Input()
    pieces: Array<PiecePostale>;

    adderValue: string;

    onPiecePostaleAdd() {
        if (!isEmpty(this.adderValue)) {
            this.pieces.push(new PiecePostale(this.adderValue));
            this.adderValue = '';
        }
    }

    onPiecePostaleDelete(index: number) {
        this.pieces.splice(index, 1);
    }

    deletePieceWithEmptyLibelle(index: number) {
        if (isEmpty(this.pieces[index].libelle)) {
            this.onPiecePostaleDelete(index);
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/piece-postales/piece-postales.component.ts